import { useEffect, useState } from 'react';
import { WrapperCard } from './WrapperCard';
import { getCurrency } from './utils/currency';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { apiSubscription } from '../../../api/apiSubscription.api';
import { toast } from 'react-toastify';

const formattedDate = (date) => {
  return date
    ? new Date(date).toLocaleDateString('ru-Ru', {
        day: 'numeric',
        month: 'long',
      })
    : 'Дата не найдена';
};

function configPayment({ status, nextPaymentDate, currency, amountPayment }) {
  const badge = {
    active: () => (
      <span className="rounded-full bg-[#A1F69E] text-[#032B2B] text-xs font-semibold px-2 py-[3px]">Активна</span>
    ),
    inactive: () => (
      <span className="rounded-full bg-neutral-300 text-[#032B2B] text-xs font-semibold px-2 py-[3px]">Неактивна</span>
    ),
    expired: () => (
      <span className="rounded-full bg-[#CE5D49] text-[#FFFFFF] text-xs font-semibold px-2 py-[3px]">
        Ошибка оплаты
      </span>
    ),
    canceled: () => (
      <span className="rounded-full bg-[#CE5D49] text-[#FFFFFF] text-xs font-semibold px-2 py-[3px]">Отменена</span>
    ),
    trial: () => (
      <span className="rounded-full bg-[#FFA600] text-[#010D0D] text-xs font-semibold px-2 py-[3px] text-center">
        Пробный период
      </span>
    ),
  };

  const price = {
    active: () => (
      <p className="text-base font-medium flex items-center">
        {amountPayment}
        {(getCurrency[currency] || getCurrency.default)()}
      </p>
    ),
    inactive: () => <></>,
    canceled: () => (
      <p className="text-base font-medium flex items-center">
        {amountPayment}
        {(getCurrency[currency] || getCurrency.default)()}
      </p>
    ),
    expired: () => (
      <p className="text-base font-medium flex items-center">
        {amountPayment}
        {(getCurrency[currency] || getCurrency.default)()}
      </p>
    ),
    trial: () => (
      <p className="text-base font-medium flex items-center">
        Затем {amountPayment} {(getCurrency[currency] || getCurrency.default)()} <span className="ml-1">/мес</span>
      </p>
    ),
  };

  const title = {
    active: () => <p className="text-xs font-semibold text-white opacity-70">Предстоящее списание:</p>,
    inactive: () => <></>,
    canceled: () => <p className="text-xs font-semibold text-white opacity-70">Истекает:</p>,
    expired: () => <p className="text-xs font-semibold text-[#FF5334] opacity-70">Не прошёл платёж:</p>,
    trial: () => <p className="text-xs font-semibold text-white opacity-70">Предстоящее списание:</p>,
  };

  const subtitle = {
    active: () => <p className="text-xs font-normal text-white opacity-70">{formattedDate(nextPaymentDate)}</p>,
    inactive: () => <></>,
    canceled: () => <p className="text-xs font-normal text-white opacity-70">{formattedDate(nextPaymentDate)}</p>,
    expired: () => <p className="text-xs font-normal text-[#FF5334] opacity-70">{formattedDate(nextPaymentDate)}</p>,
    trial: () => <p className="text-xs font-normal text-white opacity-70">{formattedDate(nextPaymentDate)}</p>,
  };

  const resumeButtonSubscription = {
    expired: ({ onClick }) => (
      <button onClick={onClick} className="bg-[#A1F69E] text-[#010D0D] p-2 w-full rounded-full text-center font-medium">
        Возобновить подписку
      </button>
    ),
    canceled: ({ onClick }) => (
      <button onClick={onClick} className="bg-[#A1F69E] text-[#010D0D] p-2 w-full rounded-full text-center font-medium">
        Возобновить подписку
      </button>
    ),
  };

  return {
    Badge: badge[status] || badge.inactive,
    Title: title[status] || title.inactive,
    Subtitle: subtitle[status] || subtitle.inactive,
    Price: price[status] || price.inactive,
    ResumeButtonSubscription: resumeButtonSubscription[status] || null,
  };
}

export function PaymentStatus({ subscribe, onRefresh }) {
  const axiosPrivate = useAxiosPrivate();

  const resumeSubscription = async () => {
    try {
      await apiSubscription.resume(axiosPrivate);
      onRefresh?.();
    } catch (error) {
      console.error('Ошибка при возобновлении подписки:', error);
      toast.error(error.response.data.message || "Ошибка")
    }
  };

  if (!subscribe) return null;

  const { Badge, Title, Subtitle, Price, ResumeButtonSubscription } = configPayment({
    status: subscribe.status,
    nextPaymentDate: subscribe.nextPayment.date,
    currency: subscribe.payment.currency,
    amountPayment: subscribe.nextPayment.amount,
  });

  return (
    <>
      <WrapperCard className="text-white relative">
        <div className="relative z-[1] space-y-[9.5px]">
          <div className="flex items-center gap-2">
            <p className="uppercase text-base font-bold">Myta premium</p>
            <Badge />
          </div>
          <Price />
          <div>
            <Title />
            <Subtitle />
          </div>
        </div>
        <img
          src="/icons/premium-subscribe-banner.svg"
          alt="icon"
          className="h-full absolute top-0 bottom-0 right-0 z-0"
        />
      </WrapperCard>
      {ResumeButtonSubscription && <ResumeButtonSubscription onClick={resumeSubscription} />}
    </>
  );
}
